(function () {
  'use strict';

  var mainImg = document.getElementById('product-main-img');
  var thumbs = document.querySelectorAll('.product-gallery-thumb');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = this.getAttribute('data-src');
      var srcset = this.getAttribute('data-srcset');
      var alt = this.getAttribute('data-alt');

      if (mainImg && src) {
        mainImg.src = src;
        if (srcset) {
          mainImg.srcset = srcset;
        } else {
          mainImg.removeAttribute('srcset');
        }
        if (alt) mainImg.alt = alt;
      }

      thumbs.forEach(function (t) {
        t.classList.remove('active');
      });
      this.classList.add('active');
    });
  });

  var qtyInput = document.getElementById('product-qty');
  var qtyMinus = document.getElementById('product-qty-minus');
  var qtyPlus = document.getElementById('product-qty-plus');

  if (qtyInput && qtyMinus) {
    qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
  }

  if (qtyInput && qtyPlus) {
    qtyPlus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      var max = parseInt(qtyInput.getAttribute('max'), 10) || 99;
      if (v < max) qtyInput.value = v + 1;
    });
  }

  // Auto-ship purchase options (only present when the product has a selling plan).
  // The hidden selling_plan input is enabled only while "Auto-ship" is selected, so the
  // native Add To Cart submit and the Checkout button below both carry the right plan.
  var po = document.querySelector('[data-fw-po]');
  var poInput = po ? po.querySelector('[data-fw-po-input]') : null;
  if (po) {
    var poSub = po.querySelector('[data-fw-po-sub]');
    var poFreq = po.querySelector('[data-fw-po-freq]');
    var poSubPrice = po.querySelector('[data-fw-po-subprice]');
    var poRadios = po.querySelectorAll('input[name="fw_purchase"]');
    var poSync = function () {
      var checked = po.querySelector('input[name="fw_purchase"]:checked');
      var isSub = !!checked && checked.value === 'sub';
      poRadios.forEach(function (r) {
        var opt = r.closest('.fw-po__opt');
        if (opt) opt.classList.toggle('is-active', r.checked);
      });
      if (poSub) poSub.hidden = !isSub;
      if (poInput) {
        poInput.disabled = !isSub;
        if (poFreq) poInput.value = poFreq.value;
      }
      if (poFreq && poSubPrice) {
        var o = poFreq.options[poFreq.selectedIndex];
        if (o && o.getAttribute('data-price')) poSubPrice.textContent = o.getAttribute('data-price');
      }
      // Each frequency can carry its own discount, so the "save N%" label follows the selection.
      var poPct = po.querySelector('[data-fw-po-pct]');
      if (poFreq && poPct) {
        var sel = poFreq.options[poFreq.selectedIndex];
        var pct = sel ? parseFloat(sel.getAttribute('data-pct')) : 0;
        poPct.textContent = pct > 0 ? ' and save ' + (Math.round(pct * 100) / 100) + '%' : '';
      }
    };
    poRadios.forEach(function (r) { r.addEventListener('change', poSync); });
    if (poFreq) poFreq.addEventListener('change', poSync);
    poSync();
  }

  // Checkout button: add the selected variant to the cart, then go straight to
  // checkout (skipping the cart page). Without this it was a bare link to /cart,
  // so buying straight from a product page landed on an empty cart.
  var checkoutBtn = document.getElementById('product-checkout-btn');
  var productForm = document.getElementById('product-form-finewines');

  if (checkoutBtn && productForm) {
    checkoutBtn.addEventListener('click', function (e) {
      e.preventDefault();

      if (checkoutBtn.getAttribute('data-busy') === '1') return;

      var checkoutUrl = checkoutBtn.getAttribute('data-checkout-url') || '/checkout';
      var variantInput = document.getElementById('product-variant-id');
      var variantId = variantInput ? parseInt(variantInput.value, 10) : 0;
      var quantity = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
      var sellingPlan = (poInput && !poInput.disabled && poInput.value) ? parseInt(poInput.value, 10) : null;

      if (!variantId) {
        window.location.href = checkoutUrl;
        return;
      }

      var label = checkoutBtn.textContent;
      checkoutBtn.setAttribute('data-busy', '1');
      checkoutBtn.setAttribute('aria-busy', 'true');
      checkoutBtn.textContent = 'Just a moment...';

      function release() {
        checkoutBtn.removeAttribute('data-busy');
        checkoutBtn.removeAttribute('aria-busy');
        checkoutBtn.textContent = label;
      }

      function fail(message) {
        release();
        window.alert(message || 'Sorry, we could not add this item. Please try again.');
      }

      // Skip the add if this variant is already in the cart, so clicking Add To
      // Cart and then Checkout does not double the quantity.
      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          var already = (cart.items || []).some(function (item) {
            var sameVariant = item.id === variantId || item.variant_id === variantId;
            var itemPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
              ? item.selling_plan_allocation.selling_plan.id : null;
            return sameVariant && itemPlan === sellingPlan;
          });

          if (already) return null;

          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [sellingPlan ? { id: variantId, quantity: quantity, selling_plan: sellingPlan } : { id: variantId, quantity: quantity }] })
          }).then(function (r) {
            if (r.ok) return r.json();
            return r.json().then(
              function (d) { throw new Error(d.description || d.message || ''); },
              function () { throw new Error(''); }
            );
          });
        })
        .then(function () { window.location.href = checkoutUrl; })
        .catch(function (err) { fail(err && err.message); });
    });
  }

  var tabBtns = document.querySelectorAll('.product-tabs-nav button[role="tab"]');
  var tabPanels = document.querySelectorAll('.product-tab-panel');

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = this.getAttribute('aria-controls');

      tabBtns.forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      tabPanels.forEach(function (p) {
        p.classList.remove('active');
      });

      this.classList.add('active');
      this.setAttribute('aria-selected', 'true');

      var panel = document.getElementById(id);
      if (panel) panel.classList.add('active');
    });
  });
})();
